import { taskDefinitionSchema } from "@gearbox-protocol/deploy-tools-shared";
import { z } from "zod";

const kvSchema = z.object({ key: z.string().min(1), value: z.string() });

const FILENAME_RE = /^[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+$/;

// validated on the array so that the message is shown for the whole field
export const artifactFilesSchema = z
  .array(z.file())
  .refine(
    files => files.every(f => FILENAME_RE.test(f.name)),
    "malformed filename: only letters, digits, - and _ are allowed",
  );

export const taskDefinitionFormSchema = taskDefinitionSchema.extend({
  artifacts: artifactFilesSchema.optional(),
  env: z.array(kvSchema).optional(),
  secrets: z.array(kvSchema).optional(),
});

export type TaskDefinitionFormSchema = z.infer<typeof taskDefinitionFormSchema>;

export const taskDefinitionFormOverrideSchema =
  taskDefinitionFormSchema.partial({
    image: true,
  });

export type TaskDefinitionFormOverrideSchema = z.infer<
  typeof taskDefinitionFormOverrideSchema
>;
